/**
 * Swaps a product card's primary image to the hovered colorway's media.
 *
 * Purely additive: the swatches are links, so with JS unavailable they still navigate to the
 * variant. The original src/srcset is captured on first swap and restored on mouseleave, which
 * also keeps the card's secondary-image-on-hover behaviour intact when the pointer leaves.
 */
class CardSwatches extends HTMLElement {
  connectedCallback() {
    this.card = this.closest('.card-wrapper');
    this.image = this.card?.querySelector('.card__inner .card__media img');
    if (!this.image) return;

    this.original = null;

    this.addEventListener('pointerover', this.onPointerOver.bind(this));
    this.addEventListener('pointerleave', this.restore.bind(this));
  }

  onPointerOver(event) {
    const swatch = event.target.closest('[data-swap-media]');
    if (!swatch) return;

    const src = swatch.dataset.swapMedia;
    if (!src || this.image.currentSrc === src) return;

    if (!this.original) {
      this.original = { src: this.image.src, srcset: this.image.srcset };
    }

    // A single resolved URL has no candidates to choose between, so srcset must go or the
    // browser keeps picking from the old set.
    this.image.srcset = '';
    this.image.src = src;

    this.querySelectorAll('.card-swatches__item--active').forEach((el) =>
      el.classList.remove('card-swatches__item--active')
    );
    swatch.classList.add('card-swatches__item--active');
  }

  restore() {
    if (!this.original) return;

    this.image.src = this.original.src;
    this.image.srcset = this.original.srcset;
    this.original = null;

    this.querySelectorAll('.card-swatches__item--active').forEach((el) =>
      el.classList.remove('card-swatches__item--active')
    );
  }
}

customElements.define('card-swatches', CardSwatches);
